const SERVICE_WORKER_URL = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

export const registerServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return null;

  try {
    return await navigator.serviceWorker.register(SERVICE_WORKER_URL, {
      scope: "/",
    });
  } catch (error) {
    console.error("No fue posible registrar la PWA:", error);
    return null;
  }
};

export const getServiceWorkerRegistration = async () => {
  if (!("serviceWorker" in navigator)) return null;

  const existingRegistration = await navigator.serviceWorker.getRegistration("/");
  return existingRegistration || registerServiceWorker();
};

export const unregisterServiceWorkers = async () => {
  if (!("serviceWorker" in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));
};
